import imageCompression from 'browser-image-compression';

export const convertAndCompressImage = async (file) => {
  if (!file) return null;

  // Validasi tipe file
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Format file tidak didukung');
  }

  if (file.type === 'application/pdf') {
    return file;
  }

  const options = {
    maxSizeMB: 1,                // target max 1MB
    maxWidthOrHeight: 1280,      // resize jika terlalu besar
    useWebWorker: true,
    fileType: 'image/jpeg',      // paksa output jadi JPG
    initialQuality: 0.8          // kualitas awal
  };

  try {
    const compressedFile = await imageCompression(file, options);

    // Rename agar ekstensi .jpg
    const newFileName =
      Date.now() + '-' + Math.round(Math.random() * 1e9) + '.jpg';

    const finalFile = new File(
      [compressedFile],
      newFileName,
      { type: 'image/jpeg' }
    );

    return finalFile;

  } catch (error) {
    console.error('Gagal proses gambar:', error);
    throw error;
  }
};